import React from 'react'
import { pushDatalayer } from '../seo/datalayer'
import { parseMediaVideoFile } from '../utils/parseMedia'
import { CookiePlaceholder } from './cookiePlaceholder'

export const Video = ({
  url,
  videoCookieAccepted,
  acceptVideoCookie,
}: {
  url: string
  videoCookieAccepted: boolean
  acceptVideoCookie: () => void
}) => {
  const { provider, id } = parseMediaVideoFile(url)
  const language = document.documentElement.lang || 'en'

  return !videoCookieAccepted && provider != 'html5' ? (
    <CookiePlaceholder acceptCookie={acceptVideoCookie} />
  ) : (provider == 'html5' ? (
        <video 
          src={url} 
          preload="metadata" 
          controls
          playsInline
          controlsList="nodownload"
        />
      ) : provider == 'vimeo' ? (
        <iframe 
          src={`https://player.vimeo.com/video/${id}`} 
          referrerPolicy='strict-origin-when-cross-origin'
        ></iframe>
      ) : provider == 'youtube' ? (
        <iframe 
          src={`https://www.youtube.com/embed/${id}?playsinline=1&preload=metadata&enablejsapi=1&showinfo=0&rel=0&modestbranding=1&cc_load_policy=1&cc_lang_pref=${language}&hl=${language}&origin=${window.location.origin}`} 
          referrerPolicy='strict-origin-when-cross-origin'
        ></iframe>
      ) : (
        <></>
      )
  )
}
